import {lazy, Suspense} from "react";
import CircularLoader from "../../../customs/loader/main";


const Main = lazy(() => import("../../../components/application/corporateProfileUpdate/changeOfAddress/main"));

const CorporateProfileUpdateChangeOfAddress = () => {

    return(

        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>
      
    )
};

export default CorporateProfileUpdateChangeOfAddress;